<div #container class="expand-container" [ngClass]="expandContainerClass">
  <div #content class="expand-content" [ngClass]="expandContentClass">
    <ng-content />
  </div>
</div>
